<main class="flex flex-col h-screen overflow-hidden">
    <app-header [side_drawer]="side_drawer" [parent]="this"></app-header>

    <mat-drawer-container class="flex-1">
      <mat-drawer #side_drawer [mode]="'over'" [opened]="false" class="w-64">
        <app-side-bar [side_drawer]="side_drawer"></app-side-bar>
      </mat-drawer>
      <mat-drawer-content class="p-6">
        @if (connectError()) {
          <div class="flex flex-col items-start gap-3 p-6 max-w-xl" role="alert">
            <h2 class="text-lg font-semibold">Could not connect to this environment</h2>
            <p class="text-sm">{{ connectError() }}</p>
            <div class="flex gap-3">
              <button type="button" mat-stroked-button (click)="retryConnect()">Retry</button>
              <a mat-flat-button routerLink="/projects/list">Back to projects</a>
            </div>
          </div>
        } @else {
          <router-outlet></router-outlet>
        }
      </mat-drawer-content>
    </mat-drawer-container>
  </main>